import configDefault from './default';
import type { ConferenceConfig } from './types';

const wehagoTestConfig: ConferenceConfig = {
  ...(configDefault as ConferenceConfig),
  hosts: {
    domain: 'rtctest.wehago.com',
    muc: 'conference.rtctest.wehago.com',
  },
  bosh: '//rtctest.wehago.com/http-bind',
  websocket: 'wss://rtctest.wehago.com/xmpp-websocket',
};

export default wehagoTestConfig;
